import { BaseResource } from 'utils/ApiUtils';


export default class SampleForm extends BaseResource {
    constructor(args, attr = SampleForm.attributes) {
        super(args, attr)
    }
    static columns = [
        { title: "formId", field: "formId", hide: true },
        { title: "material", field: "material", hide: true },
        { title: "Test Forms", field: "formDesc" },
        { title: "Pass Fail", field: "passfail" },
        { title: "Date Created", field: "DateCreated", type: "date", defaultSort: "desc" },
        { title: "File Friendly Name", field: "FileFriendlyName", type: "string", hide: true },
        { title: "Pass Fail", field: "PassFailId", hide: true },
        { title: "Attachment", field: "FileUploadUid", sorting: false },
        { title: "jsonSchema", field: "jsonSchema", hide: true },
        { title: "jsonValues", field: "jsonValues", hide: true },
        { title: "BaseSampleId", field: "BaseSampleId", hide: true },
        { title: "LabResultId", field: "LabResultId", hide: true },
        { title: "TestedBy", field: "TestedBy", hide: true },
    ]
    static attributes = SampleForm.columns.map(r => r.field)
};

